<template>
  <div>
      <v-footer
        absolute
        padless
        class="grey lighten-2 font-weight-medium"
      >
        <v-col cols="12" class=" footer-column text-center" >
          <v-btn 
            href="https://agentos.com/owners-app" 
            target="_blank"
            class="overline my-0"
            text
          >
            {{ new Date().getFullYear() }} - ownersApp BETA
          </v-btn>
        </v-col>
      </v-footer>
  </div>
</template>

<script>
  export default {

  }
</script>
<style scoped>
      @media (min-width: 1264px) {
        .footer-column{
          margin-left:90px;
        }
    }
</style>

